import ROLES from './Roles.enum';
import STATUS from './Status.enum';

export default {
  ROLES,
  STATUS,
};
